import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=0d091294&scoped=true&"
import script from "./Faq.vue?vue&type=script&lang=js&"
export * from "./Faq.vue?vue&type=script&lang=js&"
import style0 from "./Faq.vue?vue&type=style&index=0&id=0d091294&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d091294",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SidebarAnchors: require('/home/bitrix/frontend/components/other/SidebarAnchors.vue').default,Button: require('/home/bitrix/frontend/components/other/Button.vue').default,MtModal: require('/home/bitrix/frontend/components/Modal/MtModal.vue').default,LeftAside: require('/home/bitrix/frontend/components/other/LeftAside.vue').default,FaqItems: require('/home/bitrix/frontend/components/faq/FaqItems.vue').default})
